import PropTypes from "prop-types";
import { useMemo, useState } from "react";
// material
import { CssBaseline, ThemeOptions } from "@mui/material";
import {
  ThemeProvider as MUIThemeProvider,
  createTheme,
  StyledEngineProvider,
  Theme,
} from "@mui/material/styles";
import { trTR, enUS } from "@mui/material/locale";

//
import palette from "./palette";
import typography from "./typography";
import componentsOverride from "./overrides";
import shadows, { customShadows } from "./shadows";
import { useAppSelector } from "@hooks";

// ----------------------------------------------------------------------

ThemeProvider.propTypes = {
  children: PropTypes.node,
};

export default function ThemeProvider({ children }: any) {
  const language = useAppSelector((state) => state.common.language);

  const themeOptions: ThemeOptions | any = useMemo(
    () => ({
      palette,
      shape: { borderRadius: 8 },
      typography,
      shadows,
      customShadows,
    }),
    []
  );

  const theme: Theme = createTheme(themeOptions);
  theme.components = componentsOverride(theme);

  const themeWithLocale = useMemo(
    () => createTheme(theme, language === "tr" ? trTR : enUS),
    [language, theme]
  );

  return (
    <StyledEngineProvider injectFirst>
      <MUIThemeProvider theme={themeWithLocale}>
        <CssBaseline />
        {children}
      </MUIThemeProvider>
    </StyledEngineProvider>
  );
}
